import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IIntervalDataSourceSelectProps {
    value: (number | string)[] | undefined;
    onChange: (value: (number | string)[]) => void;
    options: ISelectOption<number | string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const IntervalDataSourceFilterSelect: React.FC<IIntervalDataSourceSelectProps> = ({
    disabled = false,
    value = [],
    onChange,
    label,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            searchable={false}
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={220}
        />
    );
};
